import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { DateToShortOrLongReadable } from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import { PetDetailsPropTypes } from '../../propTypes/petDetails';
import { PetIcon } from '../petIcon/petIcon';
import { PetImageUploadPopup } from './petImageUploadPopup';
import './petProfileEditor.scss';
import { formatToMonthYear } from '../../utils/date';
import { FeatureFlagContext } from '../../contextProviders/featureFlagContext';
import { usePetPhotoUrl } from '../../hooks/usePetPhotoUrl';

export const PetProfileEditor = ({ petDetail }) => {
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isShortBirthdate = cspConfiguration?.IsShortBirthdate || false;
  const { FullPolicyNumber, Name, Species, Breed, PetProfilePicture, PetBackGroundImage, PolicyDetails, DateOfBirth } =
    petDetail;

  const [profileImage, setPetProfileImage] = useState(PetProfilePicture);
  const [coverImage, setCoverImage] = useState(PetBackGroundImage);
  const [isUploadPopupActive, setIsUploadPopupActive] = useState(false);
  const coverImageUrl = usePetPhotoUrl(coverImage, FullPolicyNumber);
  const { PetGender } = PolicyDetails;
  const birthday = new Date(DateOfBirth);

  const handleClose = () => {
    setIsUploadPopupActive(false);
  };
  const handleImageEdit = () => {
    setIsUploadPopupActive(true);
  };

  return (
    <section
      style={coverImageUrl ? { backgroundImage: `url(${coverImageUrl})` } : {}}
      className="petProfileEditor"
    >
      <div className="petImageEditor">
        <div className="petProfileSummary">
          <span className="petProfileThumbnail">
            <PetIcon
              profilePic={profileImage}
              fullPolicyNumber={FullPolicyNumber}
              gender={PetGender}
              species={Species}
            />
            <Icon
              customCssClass="cameraIcon"
              icon="camera-outline"
              onClick={handleImageEdit}
            />
          </span>
          <h3>{Name}</h3>
          <span className="petDetails">
            <span className="petDetail">
              <Icon icon={`gender-${PetGender.toLowerCase()}`} />
              {Breed}
            </span>
            <span className="petDetail">
              <Icon icon="cake" />
              {isShortBirthdate ? formatToMonthYear(birthday) : DateToShortOrLongReadable(birthday)}
            </span>
          </span>
        </div>
      </div>

      {isUploadPopupActive && (
        <PetImageUploadPopup
          handleClose={handleClose}
          FullPolicyNumber={FullPolicyNumber}
          species={Species}
          gender={PetGender}
          profileImage={profileImage}
          setPetProfileImage={setPetProfileImage}
          coverImage={coverImage}
          setCoverImage={setCoverImage}
          petName={Name}
        />
      )}
    </section>
  );
};

PetProfileEditor.propTypes = {
  petDetail: PropTypes.shape(PetDetailsPropTypes)
};
